import Axios from "axios"

export default {

  /**
   * 标签列表
   */
  tagList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/listAllExternalStaffTag`);
  },

  /**
   * 添加标签
   * @param {*} external_staff_tag_name 
   */
  addTag(
    external_staff_tag_name
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/createExternalStaffTag`, {
      external_staff_tag_name
    });
  },
  
  /**
   * 编辑标签
   * @param {*} tag_id 
   * @param {*} external_staff_tag_name 
   */
  editTag(
    tag_id,
    external_staff_tag_name
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/saveExternalStaffTag/${tag_id}`, {
      external_staff_tag_name
    });
  },
  
  /**
   * 删除标签
   * @param {*} tag_id 
   */
  delTag(
    tag_id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/deleteExternalStaffTag/${tag_id}`)
  },

  /**
   * 列表分页
   * @param {*} external_staff_tag_ids 
   * @param {*} keyword 
   * @param {*} page 
   */
  listPage(
    external_staff_tag_ids,
    keyword,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/page`, {
      params: {
        external_staff_tag_ids,
        keyword,
        page
      }
    });
  },

  /**
   * 编辑
   * @param {*} id 
   * @param {*} external_staff_name 
   * @param {*} external_staff_phone 
   * @param {*} external_staff_company 
   * @param {*} external_staff_position 
   * @param {*} external_staff_tag_ids 
   * @param {*} external_staff_other 
   */
  edit(
    id,
    external_staff_name,
    external_staff_phone,
    external_staff_company,
    external_staff_position,
    external_staff_tag_ids,
    external_staff_other
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/saveExternalStaffAttr/${id}`, {
      external_staff_name,
      external_staff_phone,
      external_staff_company,
      external_staff_position,
      external_staff_tag_ids,
      external_staff_other
    });
  },
  
  /**
   * 详情
   * @param {*} id 
   */
  info(
    id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/getExternalStaffAttr/${id}`);
  }

}